import React, { Component } from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import { Link, withRouter } from "react-router-dom";

import { signIn } from "../../../actions/authActions";
import { RESPONSE_STATUS } from "../../../utils/constants";

import "./AthLogin.css";

class AthLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      currentTarget: "",
      redirFromRecommendations: false
      // redirFromRecommendations: this.props.lastLocation ? true : false
    };
  }

  componentWillMount() {
    if (localStorage.getItem("ath_auth_token")) {
      this.props.history.push("/ath/profile");
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isAuthenticated || localStorage.getItem("ath_auth_token")) {
      this.props.history.push("/ath/profile");
    }
  }

  componentDidMount() {
    ReactDOM.findDOMNode(this.refs.email).focus();
  }

  componentDidUpdate(prevProps, prevState) {
    ReactDOM.findDOMNode(this.refs.email).value = this.state.email;
    ReactDOM.findDOMNode(this.refs.password).value = this.state.password;
    this.state.currentTarget === "email"
      ? ReactDOM.findDOMNode(this.refs.email).focus()
      : ReactDOM.findDOMNode(this.refs.password).focus();
  }

  handleChange = e => {
    if (e.target.name === "email") {
      this.setState({
        email: e.target.value,
        currentTarget: "email"
      });
    }

    if (e.target.name === "password") {
      this.setState({
        password: e.target.value,
        currentTarget: "password"
      });
    }
  };

  moveCaretAtEnd = e => {
    e.target.value = "";
    e.target.value =
      e.target.name === "email" ? this.state.email : this.state.password;
  };

  renderEmailErrorMessage = () => {
    const hideErrorMessage =
      this.props.authFailed &&
      this.props.error.statusCode === RESPONSE_STATUS.NOT_FOUND
        ? ""
        : "hide-me-transparent";
    return (
      <div className={"error-message " + hideErrorMessage}>
        {this.props.error.message}
      </div>
    );
  };

  renderPasswordErrorMessage = () => {
    const hideErrorMessage =
      this.props.authFailed &&
      this.props.error.statusCode === RESPONSE_STATUS.UNAUTHORIZED
        ? ""
        : "hide-me-transparent";
    return (
      <div className={"error-message " + hideErrorMessage}>
        {this.props.error.message}
      </div>
    );
  };

  handleSubmit = e => {
    e.preventDefault();
    const { email, password } = this.state;
    if (email && password) {
      this.props.dispatch(signIn(email, password));
    }
  };

  render() {
    let enabled = {
      border: 0,
      background: "#ffad94",
      textDecoration: "none",
      color: "#ffffff"
    };
    return (
      <div id="ath-login" className="ath-login">
        <div className="signin">
          <div className="form">
            <div className="title">Log In</div>
            <div className="form-input-row">
              <input
                type="text"
                ref="email"
                name="email"
                placeholder="Email"
                value={this.state.email}
                onFocus={this.moveCaretAtEnd}
                onChange={this.handleChange}
              />
            </div>
            {this.renderEmailErrorMessage()}
            <div className="form-input-row">
              <input
                type="password"
                ref="password"
                name="password"
                value={this.state.password}
                placeholder="Password"
                onFocus={this.moveCaretAtEnd}
                onChange={this.handleChange}
              />
            </div>
            {this.renderPasswordErrorMessage()}
            <div className="form-action-row">
              <button
                style={this.state.email && this.state.password ? enabled : null}
                disabled={!this.state.email && !this.state.password}
                onClick={this.handleSubmit}
              >
                Log In
              </button>

              <div className="link-wrapper">
                <Link
                  style={{ textDecoration: "none" }}
                  to="/ath/reset-password"
                >
                  Forgot Password
                </Link>
                <span style={{ padding: "0.1em 0.5em" }}>or</span>
                <Link style={{ textDecoration: "none" }} to="/ath/onboarding">
                  Get Started
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { helloava } = state;
  const { isFetching, isAuthenticated, authFailed, error } = helloava.auth;
  return { isFetching, isAuthenticated, authFailed, error };
}

export default withRouter(connect(mapStateToProps)(AthLogin));



// WEBPACK FOOTER //
// ./src/ath/views/login/AthLogin.js